import { Model } from '@appstrax/services/database';

export type MarketplaceListingStatus = 'open' | 'paused' | 'closed';

export class MarketplaceListing extends Model {
  public projectId?: string;
  public organizationId?: string;
  public ownerId?: string;

  public title: string = '';
  public organizationName: string = '';
  public category: string = '';
  public remote: boolean = true;
  public budget: number = 0;
  public timeframeWeeks: number = 0;
  public tags: string[] = [];
  public description: string = '';

  // Extra listing details
  public requirements: string[] = [];
  public deliverables: string[] = [];
  public techStack: string[] = [];
  public commitmentHoursPerWeek?: number;
  public timezone?: string;
  public startDate?: string; // ISO date

  public status: MarketplaceListingStatus = 'open';
}

